import React from 'react';

export const Subheading = ({ children }: { children: React.ReactNode }) => {
	return (
		<h2
			className={'sm:text-[14px] md:text-[16px] lg:text-[18px] m-0 p-[8px_0] text-[#CECFD2] font-semibold leading-[100%] tracking-[2px] uppercase'}
		>
			{children}
		</h2>
	);
};